import { TicketHebType, TicketRoute } from "@models/types";

const ACCOUNT_TYPE_TO_ROUTE: Record<TicketHebType, TicketRoute> = {
  "לקוח-ספק": "customers",
  "פריט": "items",
  "עבודה": "works",
  "רכב": "cars",
  "הכנסה": "incomes",
  "הוצאה": "outcomes",
  "בנק": "banks",
  "קופה": "cash-boxes",
  "מערכת": "system",
};

/**
 * Resolves the browse route segment for an account's Hebrew type.
 * @param type TicketHebType - Account type as stored on the account/entry.
 * @returns TicketRoute - Route segment used for the account's card (e.g. "customers").
 */
export function getAccountRoute(type: TicketHebType): TicketRoute {

  return ACCOUNT_TYPE_TO_ROUTE[type];
}
